
export default [
    {
        path: '/home',
        component: () => import('@/pages/home'),
        children: [
            {
                path: 'page:id',
                component: () => import('@/pages/home')
            }
        ],
        meta: {
            isActive: true,
            title: '首页'
        }
    },
    {
        path: '/honor',
        component: () => import('@/pages/honor'),
    },
    {
        path: '/introduced',
        component: () => import('@/pages/introduced'),
    },
    {
        path: '/sample',
        component: () => import('@/pages/sample'),
    },
    {
        path: '/activeDetail',
        component: () => import('@/pages/activeDetail'),
    },
    {
        path: '/enroll',
        component: () => import('@/pages/enroll'),
    },
    {
        path: '/beforeTerm',
        component: () => import('@/pages/beforeTerm'),
    },
    {
        path: '/meaning',
        component: () => import('@/pages/meaning'),
    },
    {
        path: '/',
        redirect: '/home'
    }
]